module.exports = "<div [hidden]=\"!isLoading\" class=\"text-xs-center\">\r\n  <i class=\"fa fa-cog fa-spin fa-3x\"></i> <span>{{message}}</span>\r\n</div>\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// d:/workspace/wynk_web_shoppings_3_prod/src/app/shared/loader/loader.component.html
// module id = ../../../../../src/app/shared/loader/loader.component.html
// module chunks = main